<template>
  <v-col cols="12">
    <notifications group="reportes" position="bottom right" :duration="6000" />
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-row class="mt-4 mb-2" justify="center">
        <v-col cols="12" md="8" class="d-flex flex-wrap justify-center justify-md-space-between align-center">
          
          <v-btn
            class="ma-1"
            color="primary"
            outlined
            @click="abrirDialogoCrearVariante"
          >
            Configurar Nuevo Reporte
          </v-btn>

          <!-- Botón desplegable -->
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                color="primary"
                v-bind="attrs"
                v-on="on"
                :loading="loading"
                :disabled="loading || generarDeshabilitado"
              >
                Generar Reporte
                <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="generarReporte('excel')">
                <v-list-item-title>Generar Reporte Excel</v-list-item-title>
              </v-list-item>
              <v-list-item @click="generarReporte('pdf')">
                <v-list-item-title>Generar Reporte PDF</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
            class="ma-1"
            color="success"
            :loading="descargando"
            @click="verificarDescarga"
          >
            Revisar Estado Reportes
          </v-btn>

          <v-btn
            class="ma-1"
            color="deep-purple darken-1"
            dark
            outlined
            :disabled="!varianteProgramable"
            @click="abrirDialogoProgramacion"
          >
            Programar Envio
          </v-btn>

        </v-col>
      </v-row>
      <v-row justify="center" class="mb-4">
        <v-col cols="12" md="8">
          <!-- Selector de Variante -->
          <v-row class="mb-4"> 
            <v-col cols="6" md="6">
              <v-select
                v-model="varianteSeleccionada"
                :items="opcionesVariante"
                label="Selección de reporte"
                item-value="idVariante"
                item-text="nombre"
                dense
                outlined
                return-object
                @change="cambiarVariante()"
              />
            </v-col>
            <!--<v-col cols="6" md="6" class="d-flex justify-end align-center">
              <v-btn
                small
                outlined
                color="deep-purple lighten-4"
                @click="abrirDialogoProgramacion()"
              >
                <v-icon left small color="deep-purple darken-2">mdi-calendar-clock</v-icon>
                Programar Reportes
              </v-btn>
            </v-col>-->
          </v-row>
          <v-row justify="end" class="mt-1">
            <v-col cols="auto" class="text-right">
              <div class="text-caption font-italic grey--text text-right">
                Tiempo de generación con la configuración actual: ±{{ tiempoEstimado }}
              </div>
            </v-col>
          </v-row>
          <v-card>
            <v-card-title>
              <v-row class="align-center" no-gutters style="width: 100%">
                <!-- Columna del título -->
                <v-col>
                  <span class="headline">
                    {{ varianteSeleccionada.nombre || 'Reportes Disponibles por Sección' }}
                  </span>
                  <div
                    v-if="varianteSeleccionada.idVariante != null"
                    class="caption mt-1 text--secondary"
                  >
                    Puedes modificar nombres y subtítulos de los reportes personalizados
                  </div>
                  <div v-else class="caption mt-1 text--disabled">
                    Esta es la configuración predeterminada (no editable)
                  </div>
                </v-col>

                <!-- checkbox con margen a la derecha -->
                <v-col cols="auto" class="d-flex align-center mr-6">
                  <v-checkbox
                    v-model="seleccionarTodo"
                    :label="textoSeleccion"
                    hide-details
                    dense
                  />
                </v-col>
                
                <!-- Columna del icono refresh -->
                <v-col
                  cols="auto"
                  v-if="varianteSeleccionada.idVariante !== null"
                  class="d-flex align-center"
                >
                  <v-tooltip bottom color="black" class="white--text">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="grey lighten-1"
                        style="cursor: pointer;"
                        large
                        @click="actualizarVariante()"
                      >
                        mdi-refresh
                      </v-icon>
                    </template>
                    <span class="white--text">Actualizar Reporte</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <draggable
              v-model="seccionesOrdenadas"
              item-key="seccion"
              handle=".drag-seccion-handle"
              tag="div"
            >
              <div v-for="(seccionObj, index) in seccionesOrdenadas" :key="seccionObj.seccion" class="mb-4">
                <v-row class="align-center">
                  <v-icon class="mr-2 drag-seccion-handle" color="grey" style="cursor: move;">mdi-drag</v-icon>
                  <h4 class="ma-0">{{ seccionObj.seccion }}</h4>
                </v-row>

                <draggable
                  :list="seccionObj.reportes"
                  item-key="idReporteDiario"
                  handle=".drag-handle"
                  tag="v-row"
                  class="py-2"
                  @end="onDragEnd"
                >
                  <v-col
                    v-for="(reporte, index) in seccionObj.reportes"
                    :key="reporte.idReporteDiario"
                    cols="12"
                    md="6"
                    class="d-flex"
                  >
                    <v-card outlined class="flex-grow-1 mb-2" style="position: relative;">
                      <v-card-title class="d-flex align-center">
                        <v-icon class="mr-2 drag-handle" color="grey" style="cursor: move;">
                          mdi-drag
                        </v-icon>
                        <v-checkbox
                          v-model="reporte.activo"
                          class="ma-0 mr-2"
                          :ripple="false"
                          hide-details
                        />
                        <div>
                          <strong>{{ reporte.titulo || reporte.nombreReporte }}</strong>
                          <div v-if="reporte.subTitulo" class="text-caption grey--text">
                            {{ reporte.subTitulo }}
                          </div>
                        </div>
                        <v-spacer />
                        <v-avatar size="24" style="background-color:#f5f5f5; color:#424242;">
                          {{ index + 1 }}
                        </v-avatar>
                      </v-card-title>

                      <v-card-text v-if="varianteSeleccionada.idVariante != null" class="px-4">
                        <v-text-field
                          v-model="reporte.titulo"
                          label="Título personalizado"
                          dense
                          outlined
                          hide-details
                          class="mb-2"
                        />
                        <v-text-field
                          v-model="reporte.subTitulo"
                          label="Subtítulo personalizado"
                          dense
                          outlined
                          hide-details
                        />
                      </v-card-text>

                      <v-card-text class="px-4 pt-0 pb-2 text-left">
                        <div class="text-caption text--secondary mb-2">
                          Periodo de generación del reporte
                        </div>
                        <v-chip-group
                          v-model="reporte.tipoPeriodo"
                          mandatory
                          row
                          class="d-flex"
                          active-class="grey lighten-3"
                        >
                          <v-chip
                            v-for="(option, i) in ['Ambos', 'Mes', 'Día']"
                            :key="i"
                            :value="i"
                            small
                            class="ma-1"
                            outlined
                          >
                            {{ option }}
                          </v-chip>
                        </v-chip-group>
                      </v-card-text>

                      <v-card-text
                        v-if="varianteSeleccionada.idVariante != null"
                        class="px-4 pt-0 pb-2 text-left"
                      >
                        <div class="text-caption text--secondary mb-2">
                          Formato en envío HTML
                        </div>
                        <v-chip-group
                          v-model="reporte.formatoSalida"
                          mandatory
                          row
                          class="d-flex"
                          active-class="grey lighten-3"
                        >
                          <v-chip :value="0" small class="ma-1" outlined>
                            <v-icon left small color="blue darken-2">mdi-language-html5</v-icon>
                            HTML
                          </v-chip>
                          <v-chip :value="1" small class="ma-1" outlined>
                            <v-icon left small color="red darken-2">mdi-file-pdf-box</v-icon>
                            PDF
                          </v-chip>
                        </v-chip-group>
                      </v-card-text>

                      <div style="position: absolute; bottom: 4px; left: 10px;" v-if="reporte.tipoArchivo !== undefined">
                        <v-icon
                          medium
                          color="red darken-2"
                          v-if="reporte.tipoArchivo === 0 || reporte.tipoArchivo === 2"
                          class="mr-1"
                        >
                          mdi-file-pdf-box
                        </v-icon>
                        <v-icon 
                          medium
                          color="green darken-2"
                          v-if="reporte.tipoArchivo === 1 || reporte.tipoArchivo === 2"
                        >
                          mdi-file-excel-box
                        </v-icon>
                      </div>
                      <div class="text-caption mt-1 text--disabled text-center">
                        Clave: {{ reporte.clave }}
                      </div>
                     <v-chip
                        small
                        color="red lighten-5"
                        text-color="red darken-2"
                        style="position: absolute; bottom: 4px; right: 10px; font-weight: 500;"
                        v-if="obtenerTiempoReporte(reporte)"
                      >
                        ⏱ {{ obtenerTiempoReporte(reporte) }}
                      </v-chip>
                    </v-card>
                  </v-col>
                </draggable>

                <v-divider class="my-4"></v-divider>
              </div>
            </draggable>

              <v-row justify="end">
                <v-col cols="auto">
                  <v-btn
                    color="success"
                    :loading="loading"
                    @click="guardarConfiguracion"
                  >
                    Guardar Configuración
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>

    <v-dialog v-model="mostrarModal" max-width="900" persistent>
      <v-card>
        <!-- Título -->
        <v-card-title class="headline">
          {{ modalTitulo }}
        </v-card-title>
        <div>  </div>
        <!-- Descripción más separada -->
        <v-card-subtitle>
          Aquí puedes descargar o eliminar los reportes generados recientemente.
        </v-card-subtitle>

        <!-- Contenido con scroll -->
        <v-card-text class="pa-0">
          <div style="max-height: 300px; overflow-y: auto; padding: 1ex;">
            <v-simple-table dense>
              <thead>
                <tr>
                  <th class="text-left">Solicitud</th>
                  <th class="text-left">Generado</th>
                  <th class="text-left">Nombre</th>
                  <th class="text-left">Tamaño</th>
                  <th class="text-left">Tipo</th>
                  <th class="text-left">Estado</th>
                  <th class="text-right">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!cargandoGenerados && reportesGenerados.length === 0">
                  <td colspan="7" class="text-center grey--text">
                    No hay reportes generados recientemente.
                  </td>
                </tr>

                <tr v-for="rep in reportesGenerados" :key="rep.nombre" v-if="!rep.especial">
                  <td>
                    {{ rep.fechaSolicitudParsed ? rep.fechaSolicitudParsed.toLocaleString() : 'No disponible' }}
                  </td>
                  <td>{{ rep.fechaParsed ? rep.fechaParsed.toLocaleString() : 'N/A' }}</td>
                  <td>{{ rep.pdf }}</td>
                  <td>
                    {{ rep.pesoKB ? `${rep.pesoKB} KB` : 'N/A' }}
                  </td>
                  <td>
                    <v-icon
                      small
                      :color="rep.nombre.toLowerCase().includes('.xlsx') ? 'green darken-2' : 'red darken-2'"
                    >
                      {{ rep.nombre.toLowerCase().includes('.xlsx') ? 'mdi-file-excel-box' : 'mdi-file-pdf-box' }}
                    </v-icon>
                  </td>
                  <td>
                    <v-tooltip bottom color="black" class="white--text" :key="rep.minutosRestantes" v-if="rep.enProceso">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip x-small color="red" text-color="white" v-bind="attrs" v-on="on">
                          En proceso
                        </v-chip>
                      </template>
                      <span class="white--text">
                        Se eliminará {{ rep.minutosRestantes !== null ? `en ${rep.minutosRestantes} minuto(s)` : 'pronto' }}
                      </span>
                    </v-tooltip>

                    <v-chip v-else x-small color="green" text-color="white">
                      Listo
                    </v-chip>
                  </td>
                  <td class="text-right">
                    <v-tooltip bottom color="black" class="white--text">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-if="!rep.enProceso">
                          <v-icon
                            v-on="on"
                            small
                            v-bind="attrs"
                            class="mr-2"
                            @click="descargar(rep)"
                          >
                            mdi-file-download
                          </v-icon>
                        </span>
                      </template>
                      <span class="white--text">Descargar</span>
                    </v-tooltip>

                    <v-tooltip bottom color="black" class="white--text">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-if="!rep.enProceso">
                        <v-icon
                          v-on="on"
                          v-bind="attrs"
                          small
                          class="mr-2"
                          @click="eliminar(rep)"
                        >
                          mdi-delete
                        </v-icon>
                        </span>
                      </template>
                      <span class="white--text">Eliminar</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card-text>

        <!-- Botón Cerrar tipo texto -->
        <v-card-actions>
          <v-spacer/>
          <v-btn text color="primary" @click="mostrarModal = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmarEliminar.visible" max-width="400">
      <v-card>
        <v-card-title class="headline">
          Confirmar eliminación
        </v-card-title>
        <v-card-text>
          ¿Está seguro que desea eliminar este reporte?<br>
          <small class="grey--text">Esta acción no se puede deshacer.</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="confirmarEliminar.visible = false">
            Cancelar
          </v-btn>
          <v-btn text color="red" @click="confirmarEliminarAceptar()">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogoConfirmacion.visible" max-width="400">
      <v-card>
        <v-card-title class="headline">
          Configuración guardada
        </v-card-title>
        <v-card-text>
          Los cambios se guardaron correctamente.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogoConfirmacion.visible = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogoEnProceso.visible" max-width="400">
      <v-card>
        <v-card-title class="headline">
          Reporte en proceso
        </v-card-title>
        <v-card-text>
          Ya hay un reporte generándose en este momento. Por favor espera a que termine.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialogoEnProceso.visible = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOGO CREAR VARIANTE -->
    <v-dialog v-model="dialogoVariante.visible" max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Configurar Nuevo Reporte</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="formVariante" v-model="dialogoVariante.valid" lazy-validation>
            <v-text-field
              v-if="dialogoVariante.visible"
              ref="inputNombreVariante"
              v-model="dialogoVariante.nombre"
              label="Nombre del nuevo reporte"
              :rules="[v => !!v || 'Este campo es obligatorio']"
              required
            ></v-text-field>

            <v-textarea
              v-model="dialogoVariante.descripcion"
              label="Descripción (opcional)"
              rows="2"
              auto-grow
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="dialogoVariante.visible = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="dialogoVariante.loading"
            @click="guardarVariante"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogoConfirmarActualizar.visible" max-width="500">
      <v-card>
        <v-card-title class="headline">Actualizar Reporte</v-card-title>

        <v-card-text>
          ¿Estás seguro de que deseas actualizarlo con los reportes faltantes?
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text color="grey" @click="dialogoConfirmarActualizar.visible = false">Cancelar</v-btn>
          <v-btn color="primary" @click="confirmarActualizarVariante">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogoProgramacion" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline">
          <v-icon left class="mr-2" color="deep-purple darken-2">mdi-calendar-clock</v-icon>
          Programar Reportes
        </v-card-title>

        <v-card-text>
          <v-form>
            <v-select
              v-model="varianteSeleccionadaProgramacion"
              :items="opcionesVarianteProgramacion"
              item-text="nombre"
              item-value="idVariante"
              label="Selecciona reportes"
              outlined
              dense
              return-object
            />

            <v-alert
              dense
              text
              type="info"
              class="mt-2"
            >
              Guarda la programación automática y usa la prueba inmediata para validar correo, adjunto y configuración.
            </v-alert>

            <v-select
              v-model="programacion.dias"
              :items="diasProgramacion"
              label="Días de la semana"
              multiple
              chips
              outlined
              dense
            />

            <v-select
              v-model="programacion.tipoDisparo"
              :items="[{ text: 'Hora fija', value: 0 }, { text: 'Por turno (al iniciar / al terminar)', value: 1 }]"
              item-text="text"
              item-value="value"
              label="Tipo de envío"
              outlined
              dense
              class="mt-3"
            />

            <!-- Modo hora fija -->
            <v-row v-if="programacion.tipoDisparo !== 1" dense>
              <v-col cols="12">
                <span class="subtitle-2 font-weight-medium">
                  Hora de envío del reporte
                </span>
              </v-col>

              <v-col cols="6">
                <v-select
                  v-model="programacion.hora"
                  :items="Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'))"
                  label="Hora"
                  dense
                  outlined
                />
              </v-col>

              <v-col cols="6">
                <v-select
                  v-model="programacion.minuto"
                  :items="['00', '15', '30', '45']"
                  label="Minuto"
                  dense
                  outlined
                />
              </v-col>
            </v-row>

            <!-- Modo por turno -->
            <template v-if="programacion.tipoDisparo === 1">
              <v-select
                v-model="programacion.idTurno"
                :items="turnos"
                item-text="etiqueta"
                item-value="idTurno"
                label="Turno"
                outlined
                dense
                :no-data-text="'No hay turnos configurados'"
              />
              <v-row dense>
                <v-col cols="12" sm="7">
                  <v-select
                    v-model="programacion.momentoTurno"
                    :items="[{ text: 'Al iniciar el turno', value: 0 }, { text: 'Al terminar el turno', value: 1 }]"
                    item-text="text"
                    item-value="value"
                    label="Momento"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" sm="5">
                  <v-text-field
                    v-model.number="programacion.desfaseMinutos"
                    type="number"
                    label="Desfase (min)"
                    hint="Ej. 10 = 10 min después; -5 = 5 min antes"
                    persistent-hint
                    outlined
                    dense
                  />
                </v-col>
              </v-row>
            </template>

            <v-alert
              dense
              text
              type="info"
              class="mb-3"
            >
              El envío usa el <strong>formato configurado en cada reporte</strong>:
              los marcados como <strong>HTML</strong> van en el cuerpo del correo y los
              marcados como <strong>PDF</strong> se combinan en un solo archivo adjunto.
            </v-alert>

            <v-select
              v-model="programacion.idioma"
              :items="idiomasProgramacion"
              item-text="text"
              item-value="value"
              label="Idioma del Reporte"
              outlined
              dense
            />

            <template>
              <div>
                <v-checkbox
                  v-model="usarCorreoUsuario"
                  label="Usar correo de mi usuario"
                  class="mt-2"
                  dense
                  hide-details
                />

                <v-text-field
                  v-model="programacion.correo"
                  :disabled="usarCorreoUsuario"
                  label="Correo destinatario"
                  outlined
                  dense
                />

                <v-combobox
                  v-model="programacion.correosAdicionales"
                  :items="[]"
                  label="Agregar correos adicionales"
                  multiple
                  chips
                  small-chips
                  deletable-chips
                  outlined
                  dense
                  hide-selected
                  hint="Presiona Enter y también puedes pegar varios separados por coma o punto y coma."
                  persistent-hint
                  @change="normalizarCorreosAdicionales"
                  @blur="normalizarCorreosAdicionales"
                />
              </div>
            </template>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="red" @click="dialogoProgramacion = false">Cancelar</v-btn>
          <v-btn
            text
            color="deep-purple darken-1"
            :loading="probandoEnvio"
            :disabled="!varianteSeleccionadaProgramacion || !varianteSeleccionadaProgramacion.idVariante"
            @click="probarEnvioProgramacion"
          >
            Probar envío
          </v-btn>
          <v-btn color="primary" :loading="guardandoProgramacion" @click="guardarProgramacion()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import axios from 'axios';
import draggable from 'vuedraggable';

export default {
  name: "ConfigurarAlarmaForm",
  data() {
    return {
      loading: false,
      descargando: false,
      valid: true,
      reporteListo: false,
      reporteEnProceso: false,
      ultimaFechaGenerado: null,
      mostrarModal: false,
      modalMensaje: "",
      modalTitulo: "",
      tiempoEstimado: 8,
      generarDeshabilitado: false,
      reportesGenerados: [],
      cargandoGenerados: false,
      reportesDisponibles: [],
      catalogoReportesBase: [],
      confirmarEliminar: {
        visible: false,
        reporte: null
      },
      dialogoConfirmacion: {
        visible: false
      },
      dialogoEnProceso: {
        visible: false
      },
      dialogoVariante: {
        visible: false,
        valid: false,
        loading: false,
        nombre: '',
        descripcion: ''
      },
      dialogoEditarVariante: {
        visible: false,
        nombre: '',
        idVariante: null,
        secciones: [],
        loading: false
      },
      varianteSeleccionada: {
        idVariante: null,
        nombre: 'Reportes Disponibles por Sección'
      },
      varianteSeleccionadaProgramacion: null,
      opcionesVariante: [
        { idVariante: null, nombre: 'Reportes Disponibles por Sección' }, // opción por defecto
        // ... aquí se agregan dinámicamente otras variantes desde el backend
      ],
      opcionesVarianteProgramacion: [
        { idVariante: null, nombre: 'Reportes Disponibles por Sección' }, // opción por defecto
        // ... aquí se agregan dinámicamente otras variantes desde el backend
      ],
      props: {
        idUsuario: {
          type: Number,
          required: true
        }
      },
      minutosRestantes: 15,
      dialogoConfirmarActualizar: {
        visible: false
      },
      dialogoProgramacion: false,
      guardandoProgramacion: false,
      probandoEnvio: false,
      menuHora: false,
      programacion: {
        dias: [],
        formato: '',
        idioma: 'es',
        correo: '',
        correosAdicionales: [],
        hora: '07',    // valor inicial por defecto
        minuto: '30',  // valor inicial por defecto
        tipoDisparo: 0, // 0 = hora fija, 1 = por turno
        idTurno: null,
        momentoTurno: 0, // 0 = al iniciar, 1 = al terminar
        desfaseMinutos: 0
      },
      turnos: [], // catálogo de turnos para el envío por turno
      idiomasProgramacion: [
        { text: 'Español', value: 'es' },
        { text: 'Inglés', value: 'en' }
      ],
      usarCorreoUsuario: false,
      correoUsuario: 'usuario@dominio.com',
      diasNombre: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      diasProgramacion: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
      // 0 = PDF, 1 = Excel, 2 = HTML (el reporte se incrusta en el cuerpo del correo)
      formatosProgramacion: ['PDF', 'Excel', 'HTML']
    };
  },
  computed: {
    reportesAgrupados() {
      return this.reportesDisponibles.reduce((acc, r) => {
        const grupo = r.seccion || 'Otros';
        if (!acc[grupo]) acc[grupo] = [];
        acc[grupo].push(r);
        return acc;
      }, {});
    },
    textoSeleccion() {
      return this.seleccionarTodo
        ? 'Deseleccionar todo'
        : 'Seleccionar todo';
    },
    seleccionarTodo: {
      get() {
        // true sólo si **todos** los reportes están activos
        return this.reportesDisponibles.every(r => r.activo);
      },
      set(valor) {
        // marca o desmarca **todos** los reportes
        this.reportesDisponibles.forEach(r => { r.activo = valor; });
      }
    },
     seccionesOrdenadas: {
      get() {
        const agrupado = this.reportesDisponibles.reduce((acc, r) => {
          const grupo = r.seccion || 'Otros';
          if (!acc[grupo]) acc[grupo] = [];
          acc[grupo].push(r);
          return acc;
        }, {});

        return Object.entries(agrupado).map(([seccion, reportes]) => ({
          seccion,
          reportes
        }));
      },
      set(val) {
        this.reportesDisponibles = val.flatMap(grupo =>
          grupo.reportes.map(r => ({ ...r, seccion: grupo.seccion }))
        );
      }
    },
    varianteProgramable() {
      return Number(this.varianteSeleccionada?.idVariante) > 0;
    }
  },
  watch: {
    varianteSeleccionada: {
      immediate: true,
      handler(val) {
        this.cambiarVariante();
      }
    },
    varianteSeleccionadaProgramacion: {
      handler() {
        if (this.dialogoProgramacion) {
          this.cargarProgramacion();
        }
      }
    },
    reportesDisponibles: {
      handler() {
        this.recalcularTiempoEstimado();
      },
      deep: true
    },
    usarCorreoUsuario(val) {
      if (val) {
        this.programacion.correo = this.correoUsuario;
      } else {
        this.programacion.correo = '';
        // O puedes dejar el correo previo si no quieres vaciarlo
      }
    },
  },
  components: { draggable },
  async mounted() {
    this.obtenerFechaUltimoReporte();
    this.obtenerReportesDisponibles();
    this.cargarTurnos();
    try {
      const { data } = await axios.get('/ConfiguracionReporteDiario/ObtenerVariantes');
      this.opcionesVariante = [{ idVariante: null, nombre: "Reportes Disponibles por Sección" }, ...data];
      this.opcionesVarianteProgramacion = [{ idVariante: null, nombre: "Reportes Disponibles por Sección" }, ...data];
    } catch (error) {
      console.error("Error cargando variantes:", error);
    }
  },
  methods: {
    async cargarTurnos() {
      try {
        const { data } = await axios.get('/ConfiguracionReporteDiario/ObtenerTurnos');
        this.turnos = (Array.isArray(data) ? data : []).map(t => ({
          idTurno: t.idTurno,
          etiqueta: `${t.nombre}${t.inicio && t.fin ? ` (${t.inicio} - ${t.fin})` : ''}`
        }));
      } catch (error) {
        console.error('Error al cargar turnos:', error);
        this.turnos = [];
      }
    },
    notificar(tipo, mensaje) {
      // Muestra un mensaje al usuario usando vue-notification (el plugin real de la app).
      this.$notify({
        group: 'reportes',
        type: tipo, // 'success' | 'error' | 'info' | 'warn'
        title: mensaje
      });
    },
    firstText(...values) {
      for (const v of values) {
        const s = v == null ? "" : String(v).trim();
        if (s.length > 0 && s.toLowerCase() !== "null" && s.toLowerCase() !== "undefined") return s;
      }
      return "";
    },
    normalizeKeyName(k) {
      return (k == null ? "" : String(k))
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase();
    },
    findFirstTextByKeyPattern(input, patterns) {
      if (!input || typeof input !== "object") return "";
      const queue = [input];
      const seen = new Set();

      while (queue.length > 0) {
        const current = queue.shift();
        if (!current || typeof current !== "object" || seen.has(current)) continue;
        seen.add(current);

        const keys = Object.keys(current);
        for (const rawKey of keys) {
          const normalizedKey = this.normalizeKeyName(rawKey);
          const value = current[rawKey];

          if (patterns.some((rx) => rx.test(normalizedKey))) {
            const direct = this.firstText(value);
            if (direct) return direct;
          }

          if (value && typeof value === "object") {
            queue.push(value);
          }
        }
      }

      return "";
    },
    resolverTituloReporte(r) {
      return this.firstText(
        r?.nombrePersonalizado,
        r?.titulo,
        r?.nombreReporte,
        r?.NombreReporte,
        r?.clave
      );
    },
    resolverSubTituloReporte(r) {
      const directo = this.firstText(
        r?.subNombrePersonalizado,
        r?.subTitulo,
        r?.subtitulo,
        r?.SubTitulo,
        r?.Subtitulo,
        r?.nombreSubReporte,
        r?.NombreSubReporte,
        r?.subNombre,
        r?.SubNombre,
        r?.nombreSubtitulo,
        r?.NombreSubtitulo
      );
      if (directo) return directo;
      return this.findFirstTextByKeyPattern(r, [
        /sub.*titulo/,
        /titulo.*sub/,
        /subnombre/,
        /nombre.*sub/,
        /sub.*reporte/,
        /reporte.*sub/
      ]);
    },
    async obtenerReportesGenerados() {
      
      //this.obtenerReportesDisponibles();
      this.cargandoGenerados = true;

      const reportesAnteriores = [...this.reportesGenerados]; // copia actual
      try {
        const res = await axios.get('/Reportes/ObtenerReportesGenerados')
        
        this.reportesGenerados = res.data.map(r => ({
          ...r,
          fechaParsed: r.fecha === 'N/A' ? null : new Date(r.fecha.replace(' ', 'T')),
          fechaSolicitudParsed: r.fechaSolicitud ? new Date(r.fechaSolicitud.replace(' ', 'T')) : null,
          pesoKB: r.tamanoBytes ? (r.tamanoBytes / 1024).toFixed(1) : null,
          estado: r.enProceso ? 'EnProceso' : 'Listo',
          enProceso: r.enProceso,
          minutosRestantes: r.minutosRestantes ?? null,
          UrlDescarga: r.urlDescarga,
          pdf: r.pdf ? r.pdf.replace(/([A-Z])/g, ' $1').trim() : "Reporte Diario",
        }));
        } catch (e) {
          this.reportesGenerados = reportesAnteriores;
        }finally {
        this.cargandoGenerados = false
      }
    },
    abrirDialogoProgramacion() {
      const varianteActiva = this.opcionesVarianteProgramacion.find(
        v => v.idVariante === this.varianteSeleccionada?.idVariante
      );

      this.varianteSeleccionadaProgramacion =
        varianteActiva ||
        this.opcionesVarianteProgramacion.find(v => v.idVariante != null) ||
        null;

      this.dialogoProgramacion = true;
      this.reiniciarFormularioProgramacion();
      this.cargarProgramacion();
    },
    async guardarProgramacion() {
      this.guardandoProgramacion = true;
      try {
        const idVariante = this.varianteSeleccionadaProgramacion?.idVariante;
        if (!idVariante) {
          this.notificar('error',"Debes seleccionar una variante para programar.");
          return;
        }

        const diasNumericos = this.programacion.dias.map(dia => {
          return this.diasNombre.indexOf(dia);
        }).filter(dia => dia >= 0);

        if (!diasNumericos.length) {
          this.notificar('error',"Selecciona al menos un día de la semana.");
          return;
        }

        if (this.programacion.tipoDisparo === 1 && !this.programacion.idTurno) {
          this.notificar('error',"Selecciona un turno para el envío por turno.");
          return;
        }

        const correoPrincipal = this.programacion.correo?.trim();
        const correosAdicionales = this.unirCorreosAdicionales(this.programacion.correosAdicionales);

        if (!this.usarCorreoUsuario && !correoPrincipal && !correosAdicionales) {
          this.notificar('error',"Captura un correo principal, correos adicionales o usa el correo del usuario.");
          return;
        }

        const payload = {
          idVariante: idVariante,
          diasSemana: diasNumericos,
          formato: 2, // Siempre HTML: cada reporte decide HTML/PDF por su cuenta
          idioma: this.programacion.idioma || 'es',
          correoDestinatario: correoPrincipal,
          correosAdicionales: correosAdicionales,
          horaEnvio: `${this.programacion.hora}:${this.programacion.minuto}:00`,
          tipoDisparo: this.programacion.tipoDisparo,
          idTurno: this.programacion.tipoDisparo === 1 ? this.programacion.idTurno : null,
          momentoTurno: this.programacion.momentoTurno,
          desfaseMinutos: this.programacion.tipoDisparo === 1 ? (this.programacion.desfaseMinutos || 0) : 0,
          usarCorreoUsuario: this.usarCorreoUsuario,
          activo: true
        };

        await axios.post("/ConfiguracionReporteDiario/GuardarProgramacion", payload);

        this.notificar('success',"Programación registrada correctamente.");
        this.dialogoProgramacion = false;

      } catch (err) {
        console.error("Error al guardar programación:", err);
        this.notificar('error',"Error al guardar programación.");
      } finally {
        this.guardandoProgramacion = false;
      }
    },
    async probarEnvioProgramacion() {
      const idVariante = this.varianteSeleccionadaProgramacion?.idVariante;
      if (!idVariante) {
        this.notificar('error',"Selecciona una variante para probar el envío.");
        return;
      }

      this.probandoEnvio = true;
      try {
        await axios.post(`/ConfiguracionReporteDiario/ProbarEnvioProgramacion/${idVariante}`);
        this.notificar('success',"La prueba de envío se ejecutó correctamente. Revisa el correo configurado.");
      } catch (err) {
        console.error("Error al probar el envío del reporte:", err);
        const mensaje = err?.response?.data?.message || err?.response?.data || "No se pudo ejecutar la prueba de envío.";
        this.notificar('error',mensaje);
      } finally {
        this.probandoEnvio = false;
      }
    },
    generarReporte(tipo) {
      if (tipo === 'excel') {
        this.generarReporteExcel();
      } else if (tipo === 'pdf') {
        this.generarReportePDF();
      }
    },
    async cargarProgramacion() {
      try {
        const res = await axios.get("/ConfiguracionReporteDiario/ObtenerProgramaciones");
        const lista = res.data;

        const programacion = lista.find(p => p.idVariante === this.varianteSeleccionadaProgramacion?.idVariante);
        if (!programacion) {
          this.reiniciarFormularioProgramacion();
          return;
        }

        // Cargar datos al formulario si ya existe programación
        this.programacion = {
          dias: programacion.diasSemana.map(i => this.diasNombre[i]),
          formato: this.formatoNumeroATexto(programacion.formato),
          idioma: programacion.idioma || 'es',
          correo: programacion.correoDestinatario || '',
          correosAdicionales: this.separarCorreos(programacion.correosAdicionales),
          hora: this.formatearHoraProgramacion(programacion.horaEnvio),
          minuto: this.formatearMinutoProgramacion(programacion.horaEnvio),
          tipoDisparo: programacion.tipoDisparo ?? 0,
          idTurno: programacion.idTurno ?? null,
          momentoTurno: programacion.momentoTurno ?? 0,
          desfaseMinutos: programacion.desfaseMinutos ?? 0
        };
        this.usarCorreoUsuario = programacion.usarCorreoUsuario;

      } catch (err) {
        console.error("Error al cargar programación:", err);
        this.notificar('error',"No se pudo cargar la programación.");
      }
    },
    formatoTextoANumero(formato) {
      // 0 = PDF, 1 = Excel, 2 = HTML
      switch (formato) {
        case 'Excel': return 1;
        case 'HTML': return 2;
        default: return 0;
      }
    },
    formatoNumeroATexto(formato) {
      switch (formato) {
        case 1: return 'Excel';
        case 2: return 'HTML';
        default: return 'PDF';
      }
    },
    reiniciarFormularioProgramacion() {
      this.programacion = {
        dias: [],
        formato: '',
        idioma: 'es',
        correo: '',
        correosAdicionales: [],
        hora: '07',
        minuto: '30',
        tipoDisparo: 0,
        idTurno: null,
        momentoTurno: 0,
        desfaseMinutos: 0
      };
      this.usarCorreoUsuario = false;
    },
    separarCorreos(correos) {
      if (!correos || typeof correos !== "string") return [];
      return correos
        .split(/[,\n;\r]+/)
        .map(correo => correo.trim())
        .filter(Boolean);
    },
    unirCorreosAdicionales(correos) {
      if (!Array.isArray(correos)) return '';
      return correos
        .map(correo => typeof correo === "string" ? correo.trim() : '')
        .filter(Boolean)
        .join('; ');
    },
    normalizarCorreosAdicionales() {
      const origen = Array.isArray(this.programacion.correosAdicionales)
        ? this.programacion.correosAdicionales
        : [this.programacion.correosAdicionales];

      this.programacion.correosAdicionales = origen
        .flatMap(valor => {
          if (typeof valor !== "string") return [];
          return valor.split(/[,\n;\r]+/);
        })
        .map(correo => correo.trim())
        .filter(Boolean)
        .filter((correo, index, lista) => lista.findIndex(item => item.toLowerCase() === correo.toLowerCase()) === index);
    },
    formatearHoraProgramacion(horaEnvio) {
      if (!horaEnvio || typeof horaEnvio !== "string") return '07';
      const [hora] = horaEnvio.split(':');
      return String(hora || '07').padStart(2, '0');
    },
    formatearMinutoProgramacion(horaEnvio) {
      if (!horaEnvio || typeof horaEnvio !== "string") return '30';
      const [, minuto] = horaEnvio.split(':');
      return String(minuto || '30').padStart(2, '0');
    },
    onDragEnd(/* evt */) {
      // Fuerza la invocación del setter de seccionesOrdenadas
      // Para que aplanes el nuevo orden sobre reportesDisponibles
      this.seccionesOrdenadas = this.seccionesOrdenadas;
    },
    recalcularTiempoEstimado() {
      const hoy = new Date();
      const diasDelMes = hoy.getDate();
      let totalSegundos = 0;

      for (const r of this.reportesDisponibles) {
        if (!r.activo || !r.tiempoDia) continue;

        if (r.tipoPeriodo === 1) totalSegundos += r.tiempoDia * diasDelMes;
        else if (r.tipoPeriodo === 2) totalSegundos += r.tiempoDia;
        else if (r.tipoPeriodo === 0) totalSegundos += r.tiempoDia * diasDelMes + r.tiempoDia;
      }

      //Le sumo un aprox del codigo del reporte (30 seg), solo si es diferente de 0 porque si es caso contrario no se genera
      if(totalSegundos>0)
        totalSegundos = totalSegundos + 30;
      // Convertir segundos a minutos y redondear
      if (totalSegundos === 0) {
        this.tiempoEstimado = '0 min';
      } else if (totalSegundos < 60) {
        this.tiempoEstimado = `${totalSegundos.toFixed(2)} s`;
      } else if (totalSegundos < 300) {
        this.tiempoEstimado = `${(totalSegundos / 60).toFixed(1)} min`;
      } else {
        this.tiempoEstimado = `${Math.round(totalSegundos / 60)} min`;
      }
    },
    actualizarVariante() {
      this.dialogoConfirmarActualizar.visible = true;
    },
    async confirmarActualizarVariante() {
      try {
        const idVariante = this.varianteSeleccionada?.idVariante;
        if (!idVariante) return;

        const payload = this.seccionesOrdenadas.flatMap((grupo, indexSeccion) =>
          grupo.reportes.map((r, indexReporte) => ({
            idVariante,
            idReporteDiario: r.idReporteDiario,
            activo: r.activo,
            posicion: indexReporte + 1,
            posicionSeccion: indexSeccion + 1,
            nombrePersonalizado: r.titulo,
            subNombrePersonalizado: r.subTitulo,
            tipoPeriodo: r.tipoPeriodo,
            formatoSalida: r.formatoSalida ?? 0
          }))
        );

        const res = await axios.post("/ConfiguracionReporteDiario/GuardarDetalleVariante", payload);

        if (res.status === 200) {
          this.dialogoConfirmarActualizar.visible = false;
          await this.cambiarVariante();
          this.recalcularTiempoEstimado(); // ← FORZAR ACTUALIZACIÓN
          //this.notificar('success',"Variante actualizada correctamente.");
        }
      } catch (err) {
        this.dialogoConfirmarActualizar.visible = false;
        //this.notificar('error',"Error al actualizar la variante.");
      }
    },
    agruparReportesPorSeccion(reportes) {
      return reportes.reduce((grupos, reporte) => {
        const seccion = reporte.seccion || "Otros";
        if (!grupos[seccion]) grupos[seccion] = [];
        grupos[seccion].push(reporte);
        return grupos;
      }, {});
    },
    async cambiarVariante() {
      const id = this.varianteSeleccionada.idVariante;
      if (id != null) {
        try {
          if (!Array.isArray(this.catalogoReportesBase) || this.catalogoReportesBase.length === 0) {
            await this.obtenerReportesDisponibles();
          }
          const { data } = await axios.get(`/ConfiguracionReporteDiario/ObtenerDetalleVariante/${id}`);
          const baseById = new Map(
            (this.catalogoReportesBase || []).map((r) => [Number(r.idReporteDiario), r])
          );
          // 🛠️ Convertir al mismo formato de reportes estándar
          this.reportesDisponibles = data.map(r => {
            const merged = { ...(baseById.get(Number(r.idReporteDiario)) || {}), ...r };
            return {
            ...merged,
            idReporteDiario: r.idReporteDiario,
            clave: r.clave,
            titulo: this.resolverTituloReporte(merged),
            subTitulo: this.resolverSubTituloReporte(merged),
            seccion: r.seccion,
            activo: r.activo,
            checked: r.activo, // importante para checkboxes si los usas
            posicion: r.posicion,
            posicionSeccion: r.posicionSeccion,
            tipoPeriodo: r.tipoPeriodo ?? 0, // 0: Ambos, 1: Mes, 2: Día (por defecto Ambos si no viene)
            tiempoDia: r.tiempoDia,
            tipoArchivo: r.tipoArchivo !== undefined ? r.tipoArchivo : 2,
            formatoSalida: r.formatoSalida ?? 0, // 0: HTML en el cuerpo, 1: PDF adjunto (solo aplica a envío HTML)
            };
          });
          this.recalcularTiempoEstimado();
        } catch (error) {
          console.error("Error al cargar variante personalizada:", error);
        }
      } else {
        this.obtenerReportesDisponibles();
        this.recalcularTiempoEstimado();
      }
    },
    abrirDialogoCrearVariante() {
      this.dialogoVariante.visible = true;
      this.dialogoVariante.nombre = '';
      this.dialogoVariante.descripcion = '';
      
      this.$nextTick(() => {
        setTimeout(() => {
          const input = this.$refs.inputNombreVariante;
          if (input && input.focus) {
            input.focus();
          }
        }, 100); // Espera 100ms para que el input esté montado
      });
    },
    async abrirEditorVariante(variante) {
      try {
        this.dialogoEditarVariante.visible = true;
        this.dialogoEditarVariante.loading = true;
        this.dialogoEditarVariante.idVariante = variante.idVariante;
        this.dialogoEditarVariante.nombre = variante.nombre;

        const res = await axios.get(`/ConfiguracionReporteDiario/ObtenerDetalleVariante/${variante.idVariante}`);

        const agrupado = res.data.reduce((acc, r) => {
          const seccion = r.seccion || 'Otros';
          if (!acc[seccion]) acc[seccion] = [];
          acc[seccion].push({
            idReporteDiario: r.idReporteDiario, // asegúrate que esto viene del back
            titulo: this.resolverTituloReporte(r),
            subTitulo: this.resolverSubTituloReporte(r),
            activo: r.activo
          });
          return acc;
        }, {});

        this.dialogoEditarVariante.secciones = Object.entries(agrupado).map(([seccion, reportes]) => ({
          seccion,
          reportes
        }));

      } catch (e) {
        this.notificar('error',"Error al cargar variante.");
        this.dialogoEditarVariante.visible = false;
      } finally {
        this.dialogoEditarVariante.loading = false;
      }
    },
    async guardarCambiosVariante() {
      this.dialogoEditarVariante.loading = true;

      try {
        const payload = this.dialogoEditarVariante.secciones.flatMap((grupo, idxSec) =>
          grupo.reportes.map((r, idx) => ({
            idVariante: this.dialogoEditarVariante.idVariante,
            idReporteDiario: r.idReporteDiario,
            activo: r.activo,
            posicion: idx + 1,
            posicionSeccion: idxSec + 1,
            nombrePersonalizado: r.titulo,
            subNombrePersonalizado: r.subTitulo,
            tipoPeriodo: r.tipoPeriodo
          }))
        );

        await axios.post('/ConfiguracionReporteDiario/GuardarVarianteDetalle', payload);
        //this.notificar('success',"Variante actualizada.");
        this.dialogoEditarVariante.visible = false;
      } catch (err) {
        this.notificar('error',"Error al guardar cambios.");
      } finally {
        this.dialogoEditarVariante.loading = false;
      }
    },
    obtenerTiempoReporte(r) {
      if (!r.tiempoDia || !r.activo) return null;

      const diasDelMes = new Date().getDate();
      let totalSegundos = 0;

      switch (r.tipoPeriodo) {
        case 1: totalSegundos = r.tiempoDia * diasDelMes; break;     // Mes
        case 2: totalSegundos = r.tiempoDia; break;                  // Día
        case 0: totalSegundos = r.tiempoDia * diasDelMes + r.tiempoDia; break; // Ambos
      }

      const minutos = totalSegundos / 60;
      if (minutos < 1) return `${totalSegundos.toFixed(2)} s`;
      if (minutos % 1 === 0) return `${minutos} min`;
      return `${minutos.toFixed(1)} min`;
    },
    async guardarVariante() {
      const form = this.$refs.formVariante;
      if (!form || !(await form.validate())) return;

      this.dialogoVariante.loading = true;

      try {
        const payload = {
          nombre: this.dialogoVariante.nombre.trim(),
          descripcion: this.dialogoVariante.descripcion?.trim() || ''
        };

        const res = await axios.post("/ConfiguracionReporteDiario/CrearVariante", payload);

        //this.notificar('success',"Variante creada correctamente.");

        await this.cargarVariantes();
        this.varianteSeleccionada = this.opcionesVariante.find(
          v => v.idVariante === res.data.idVariante
        ) ?? this.opcionesVariante[0]; // Fallback a la predeterminada si no lo encuentra

        this.dialogoVariante.visible = false;
        await this.cambiarVariante(); // Carga los detalles de esa variante
        this.recalcularTiempoEstimado(); // ← FORZAR ACTUALIZACIÓN
      } catch (err) {
        this.notificar('error',"Error al crear la variante.");
      } finally {
        this.dialogoVariante.loading = false;
      }
    },
    async cargarVariantes() {
      try {
        const res = await axios.get("/ConfiguracionReporteDiario/ObtenerVariantes", {
          params: { idUsuario: this.idUsuario }
        });
        this.opcionesVariante = [{ idVariante: null, nombre: "Reportes Disponibles por Sección" }, ...res.data];
        this.opcionesVarianteProgramacion = [{ idVariante: null, nombre: "Reportes Disponibles por Sección" }, ...res.data];
        this.variantes = res.data;
      } catch (e) {
        console.error("Error al cargar variantes", e);
      }
    },
    async obtenerFechaUltimoReporte() {
      try {
        const res = await axios.get("/Reportes/ObtenerUltimoReporteGenerado");
        this.reporteListo = res.data.existe;
        this.reporteEnProceso = res.data.enProceso;
        this.ultimaFechaGenerado = res.data.existe ? res.data.fecha : null;
      } catch (error) {
        console.error("Error al obtener estado del reporte:", error);
      }
    },
    async obtenerReportesDisponibles() {
      try {
        const res = await axios.get("/ConfiguracionReporteDiario/ObtenerReportes", {
          params: { idUsuario: this.idUsuario }
        });
        this.catalogoReportesBase = Array.isArray(res.data) ? res.data : [];
        this.reportesDisponibles = this.catalogoReportesBase.map((r) => ({
          ...r,
          titulo: this.resolverTituloReporte(r),
          subTitulo: this.resolverSubTituloReporte(r),
        }));
      } catch (error) {
        console.error("Error al cargar reportes:", error);
        this.notificar('error',"No se pudieron cargar los reportes disponibles.");
      }
    },
    async guardarConfiguracion() {
      try {
        if (this.varianteSeleccionada.idVariante != null) {
          // Si es variante personalizada: guardar solo detalles de la variante
          const payloadDetalles = this.seccionesOrdenadas.flatMap((grupo, indexSeccion) =>
            grupo.reportes.map((r, indexReporte) => ({
              idVariante: this.varianteSeleccionada.idVariante,
              idReporteDiario: r.idReporteDiario,
              activo: r.activo,
              posicion: indexReporte + 1,
              posicionSeccion: indexSeccion + 1,
              nombrePersonalizado: r.titulo,
              subNombrePersonalizado: r.subTitulo,
              tipoPeriodo: r.tipoPeriodo,
              formatoSalida: r.formatoSalida ?? 0
            }))
          );

          await axios.post("/ConfiguracionReporteDiario/GuardarDetalleVariante", payloadDetalles);
        } else {
          // Si es la configuración predeterminada: guardar configuración general
          const payloadConfiguracion = this.seccionesOrdenadas.flatMap((grupo, indexSeccion) =>
            grupo.reportes.map((r, indexReporte) => ({
              idReporteDiario: r.idReporteDiario,
              seccion: grupo.seccion,
              posicionSeccion: indexSeccion + 1,
              posicion: indexReporte + 1,
              tipoPeriodo: r.tipoPeriodo ?? 0,
              activo: r.activo
            }))
          );

          await axios.post("/ConfiguracionReporteDiario/GuardarConfiguracion", payloadConfiguracion, {
            params: { idUsuario: this.idUsuario }
          });
        }

        this.dialogoConfirmacion.visible = true;

      } catch (error) {
        console.error("Error al guardar configuración:", error);
        this.notificar('error',"No se pudo guardar la configuración.");
      }
    },
    generarReporteExcel() {
      // Tu lógica existente o nueva para generar el Excel
      this.confirmarReporte('excel');
    },
    generarReportePDF() {
      // Tu lógica existente o nueva para generar el PDF
      this.confirmarReporte('pdf');
    },
    async confirmarReporte(tipo) {
      try {
        this.loading = true;
        this.generarDeshabilitado = true;
        const estado = await this.verificarEstadoReporte(this.tipo);
        if (estado.enProceso) {
          this.dialogoEnProceso.visible = true;

          const minutos = estado.minutosRestantes;
          if (minutos !== null) {
            this.notificar('info',`Ya hay un reporte ${tipo} en proceso. Intenta nuevamente en aproximadamente ${minutos} minuto(s).`);
          } else {
            this.notificar('info',`Ya hay un reporte ${tipo} en proceso. Intenta más tarde.`);
          }

          setTimeout(() => {
            this.generarDeshabilitado = false;
          }, 10000);

          return;
        }

        // 🔀 Lógica según tipo de reporte
        let url = "/Reportes/GenerarReporteDiarioHF"; // por defecto PDF
        if (tipo === 'excel') {
          url = "/Reportes/GenerarReporteDiarioExcelHF";
        }

        await axios.get(url, {
          params: {
            idVariante: this.varianteSeleccionada?.idVariante ?? null,
          }
        });

        this.notificar('success',"Reporte encolado. Se generará en segundo plano.");
        this.obtenerFechaUltimoReporte();

        setTimeout(() => {
          this.generarDeshabilitado = false;
        }, 10000);

      } catch (error) {
        this.notificar('error',"No se pudo encolar el reporte.");
        this.generarDeshabilitado = false;
      } finally {
        this.loading = false;
      }
    },
    async verificarEstadoReporte(tipo) {
      try {
        const estadoRes = await axios.get(`/Reportes/EstadoReporte/${tipo}`);
        return {
          enProceso: estadoRes.data?.enProceso ?? false,
          minutosRestantes: estadoRes.data?.minutosRestantes ?? null
        };
      } catch (e) {
        return { enProceso: false, minutosRestantes: null };
      }
    },
    async verificarDescarga() {
      this.modalTitulo = 'Reportes Generados';
      this.mostrarModal = true;
      this.cargandoGenerados = true;
      await this.obtenerReportesGenerados();
      this.cuentaRegresiva(); // Inicia el intervalo
    },

    async descargarDesdeModal() {
      this.mostrarModal = false;
      await this.descargarReporte();
    },

    async descargarReporte() {
      try {
        this.descargando = true;
        const response = await axios.get("/Reportes/DescargarUltimoReporte", {
          responseType: "blob"
        });

        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ReporteDiario.pdf");
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.reporteListo = false;
        this.ultimaFechaGenerado = null;
        //this.notificar('success',"Reporte descargado y eliminado.");
        this.$root.$emit("refrescarNotificaciones");
      } catch (error) {
        this.notificar('error',"Error al descargar el reporte.");
      } finally {
        this.descargando = false;
      }
    },
    cuentaRegresiva(tiempo = 5000) {
      const verificar = async () => {
        if (!this.mostrarModal) return;

        const estado = await this.verificarEstadoReporte('pdf');

        // Encuentra el primer reporte en proceso y actualiza sus valores
        const rep = this.reportesGenerados.find(r => r.enProceso);
        if (rep) {
          rep.minutosRestantes = estado.minutosRestantes;
          rep.enProceso = estado.enProceso; // podría cambiar a false si terminó
        }

        if (estado.enProceso) {
          setTimeout(verificar, tiempo);
        } else {
          await this.obtenerReportesGenerados(); // actualiza todo al finalizar
        }
      };

      setTimeout(verificar, tiempo);
    },
    async descargar(reporte) {
      try {
        this.descargando = true;

        const response = await axios.get(`/Reportes/DescargarReporteSeleccionado`, {
          params: { Nombre: reporte.nombre },
          responseType: "blob"
        });

        // Obtener nombre del archivo desde los headers
        const contentDisposition = response.headers['content-disposition'];
        let filename = reporte.nombre || 'ReporteDiario.pdf'; // fallback

        if (contentDisposition && contentDisposition.includes('filename=')) {
          filename = contentDisposition
            .split('filename=')[1]
            .replace(/["']/g, '')
            .trim();
        }

        // Detectar tipo MIME desde la extensión del archivo
        const extension = filename.split('.').pop().toLowerCase();
        const mimeTypes = {
          pdf: 'application/pdf',
          xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        };
        const mimeType = mimeTypes[extension] || 'application/octet-stream';

        // Crear y descargar blob
        const blob = new Blob([response.data], { type: mimeType });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.$root.$emit("refrescarNotificaciones");

      } catch (error) {
        this.notificar('error',"Error al descargar el reporte.");
      } finally {
        this.descargando = false;
      }
    },
    async confirmarEliminarAceptar() {
      const reporte = this.confirmarEliminar.reporte;
      this.confirmarEliminar.visible = false;

      try {
        this.descargando = true;

        const response = await axios.get(`/Reportes/EliminarReporteSeleccionado`, {
          params: { Nombre: reporte.nombre },
        });

        if (response.data === true) {
          this.notificar('success',"El reporte fue eliminado correctamente.");
          this.obtenerReportesGenerados();
        } else {
          this.notificar('error',"El reporte no se eliminó porque no cumplía los requisitos.");
        }
      } catch (error) {
        this.notificar('error',"Error al eliminar el reporte.");
      } finally {
        this.descargando = false;
      }
    },
    eliminar(reporte) {
      this.confirmarEliminar.reporte = reporte;
      this.confirmarEliminar.visible = true;
    }
  }
};
</script>
